<template>
  <div>
    <h3>Options</h3>
    <v-container
      v-if="optionsArray.length"
      fluid
      fill-height
    >
      <CronjobOptionsInput
        v-for="(value, key, index) in optionsValues"
        :key="index"
        :key-name="key"
        :option-value="value"
        :options-set="optionsSet"
        @updateOption="handleUpdateOption"
      />
      <v-row>
        <v-col>
          <v-btn
            v-if="!optionsSet"
            color="primary"
            dark
            small
            @click="setOptions()"
          >
            Set Options
          </v-btn>
          <v-btn
            v-else
            color="primary"
            dark
            small
            @click="changeOptions()"
          >
            Change Options
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-else
    >
      <v-alert
        border="top"
        color="indigo lighten-2"
        dark
      >
        These command does not need options!
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import CronjobOptionsInput from '@/views/Settings/Cronjob/RunCronjobNow/CronjobOptionsInput.vue';

export default {
  name: 'CronjobOptions',
  components: { CronjobOptionsInput },
  props: {
    optionsArray: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      optionsValues: {},
      optionsSet: false,
    };
  },

  watch: {
    optionsArray: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.initOptionsValues();
        }
      },
    },
  },

  methods: {
    initOptionsValues() {
      this.optionsValues = {};
      this.optionsArray.forEach((opt) => {
        this.$set(this.optionsValues, opt.name, { value: '', justOption: false });
      });
    },

    handleUpdateOption(option) {
      Object.keys(this.optionsValues).forEach((key) => {
        if (key === option.keyName) {
          this.optionsValues[key] = option.optionValue;
        }
      });
    },

    setOptions() {
      let hasOption = false;

      Object.keys(this.optionsValues).forEach((key) => {
        if (this.optionsValues[key].value || this.optionsValues[key].justOption) {
          hasOption = true;
        }
      });

      if (hasOption) {
        this.$emit('input', this.optionsValues);
      }

      this.optionsSet = true;
    },

    changeOptions() {
      this.$emit('input', {});
      this.optionsSet = false;
    },
  },
};
</script>
